/**
 * Movement-muscle constants - browser-safe, zero imports.
 * This is the foundation file that other movement-muscle files build upon.
 */
// The `label` (what is shown to the user) will be defined in the UI (i18n section)
const muscleRoleInMovements = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    STABILIZER: 'stabilizer',
    // @todo: just use null instead of abstract.
    // ABSTRACT: 'abstract',
};
export { muscleRoleInMovements };
//# sourceMappingURL=movement-muscle.constants.js.map